import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "./Card/Card";
import Body from "./Body/Body";
import About from "./About/About";

const LandingPage = () => {
  return (
    <>
      <Helmet>
        <title>A real time socket based schedule website</title>
        <meta
          name="description"
          content="Explore the schedule. Just add the title, duration and piority and let our product to the magic"
        />
      </Helmet>
      <div id="home_p">
        <Body />
      </div>
      <div id="body_p">
        <Card />
      </div>
      <div id="about_p">
        <About />
      </div>
    </>
  );
};

export default LandingPage;
